import React from 'react';
import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import PurchaseVatOnlyPostMutation from 'graphql/mutations/supplier/PurchaseVatOnlyPostMutation.graphql';
import PurchaseVatOnlyPostingPreview from 'graphql/entities/supplier/PurchaseVatOnlyPostingPreview';
import PurchaseVatOnlyTransactions from 'graphql/entities/supplier/PurchaseVatOnlyTransactions';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

const PURCHASE_VAT_ONLY_POSTING_PREVIEW = createPostingPreview(PurchaseVatOnlyPostingPreview);
const PURCHASE_VAT_ONLY_POSTED_TRANSACTIONS = createPostedTransactions(PurchaseVatOnlyTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: PURCHASE_VAT_ONLY_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/supplier/PurchaseVatOnly',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: PURCHASE_VAT_ONLY_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/supplier/PurchaseVatOnly',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Post Vat',
    component: PostSelectButton,
    performSave: true,
    fn: postVatOnly,
    individualButton: true,
    saveMessage: 'Vat Posted',
    condition: canBePosted,
  },
];

function displayPreview(vatOnly) {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === 'DRAFT' || vatOnly.documentStatus === 'RELEASED';
  }
  return false;
}

function displayPosted(vatOnly) {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === 'POSTED';
  }
  return false;
}

function canBePosted(vatOnly) {
  if (vatOnly && vatOnly.documentStatus) {
    return vatOnly.documentStatus === 'DRAFT' || vatOnly.documentStatus === 'RELEASED';
  }
  return false;
}

function postVatOnly(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(PurchaseVatOnlyPostMutation, input, props, 'back', 'Post Vat');
}
